import Search from 'layouts/Desktop/containers/Serach'
import Controller from './Controller'
import MobileView from './MobileView'
import Popups from './Popups'
import './style.scss'

const Maps = ({ isMobile = true }) => {
  return (
    <>
      <Controller isMobile={isMobile} />
      <Popups />
      {isMobile ? <MobileView /> : <Search />}
    </>
  )
}

export default Maps